/**
 * @file コンポーネント：利用規約英語 ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const TermsEnglish = (props) => {
    // Presenterに渡す
    return <Presenter {...props} />;
};
